import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WalletListItem } from "@/types/IProfile";
import { RootState } from "../store";

export interface ICombineWallet {
  selectedType: "sniper" | "privy";
  selectedWallet: WalletListItem;
  internalWalletList: WalletListItem[];
  privyWalletList: WalletListItem[];
  combineWalletList: WalletListItem[];
}

const initialState: ICombineWallet = {
  selectedType: "sniper",
  selectedWallet: {} as WalletListItem,
  internalWalletList: [],
  privyWalletList: [],
  combineWalletList : []
};
export const CombineWalletSlice = createSlice({
  name: "combine_wallet_slice",
  initialState,
  reducers: {
    setWalletTypeState: (state, action: PayloadAction<"sniper" | "privy">) => {
      state.selectedType = action.payload;
    },
    setSelectedWalletState: (state, action: PayloadAction<WalletListItem>) => {
      state.selectedWallet = action.payload;
    },
    setInternalWalletList: (state, action: PayloadAction<WalletListItem[]>) => {
      state.internalWalletList = action.payload;
    },
    setPrivyWalletList: (state, action: PayloadAction<WalletListItem[]>) => {
      state.privyWalletList = action.payload;
    },
    setCombineWalletList: (state, action: PayloadAction<WalletListItem[]>) => {
      state.combineWalletList = action.payload;
    },
  },
});

export const {
  setWalletTypeState,
  setSelectedWalletState,
  setInternalWalletList,
  setPrivyWalletList,
  setCombineWalletList
} = CombineWalletSlice.actions;

export const selectCombineWallet = (state: RootState) => state.combineWallet;

export default CombineWalletSlice.reducer;
